export const textAlignment = {
  attrs: {
    textAlign: {
      default: 'left'
    }
  },
  group: 'alignment',
  toDOM(mark) {
    const dom = document.createElement('span');
    dom.style.textAlign = mark.attrs.textAlign;
    dom.style.display = 'block';
    return {
      dom,
      contentDOM: dom
    };
  },
  parseDOM: [{
    style: 'text-align',
    getAttrs: textAlign => {
      return textAlign ? {
        textAlign
      } : false;
    }
  }]
};